import React, { useEffect, useState } from 'react';

import tiktokIcon from '../../images/logos/tiktok-outline.svg';

const API_BASE = process.env.REACT_APP_API_BASE || '';
const LOCAL_TEST = String(process.env.REACT_APP_LOCAL_TEST || '').toLowerCase() === 'true';

const TikTokButton = () => {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (LOCAL_TEST) { setConnected(true); return; }
    fetch(`${API_BASE}/api/me`).then(r => r.json()).then((data) => {
      setConnected(!!data.connected);
    }).catch(() => setConnected(false));
  }, []);

  const handleClick = () => {
    if (LOCAL_TEST) { window.location.href = `/dashboard`; return; }
    if (!connected) {
      window.location.href = `${API_BASE}/oauth/tiktok`;
    } else {
      window.location.href = `/dashboard`;
    }
  };

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE}/auth/logout`, { method: 'POST', credentials: 'include' });
    } catch {}
    setConnected(false);
    window.location.href = '/';
  };

  const containerStyle = {
    position: 'fixed',
    top: '12px',
    right: '12px',
    zIndex: 1100,
  };

  const buttonStyle = {
    backgroundColor: '#f3f4f6',
    color: '#000',
    border: 'none',
    borderRadius: '999px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
  };

  const iconStyle = {
    width: '20px',
    height: '20px'
  };

  return (
    <div style={containerStyle}>
      <button onClick={handleClick} style={buttonStyle} aria-label={connected ? 'Open TikTok Dashboard' : 'Connect TikTok'}>
        <img src={tiktokIcon} alt="TikTok" style={iconStyle} />
        {connected ? 'DASHBOARD' : 'CONNECT'}
      </button>
      <div style={{ marginTop: 8, display: 'flex', justifyContent: 'flex-end' }}>
        <button onClick={handleLogout} style={{ ...buttonStyle, backgroundColor: '#fee2e2' }} aria-label='Log out'>
          Log out
        </button>
      </div>
    </div>
  );
};

export default TikTokButton;


